import { Component, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { AppService } from '../../_services/app.service';
import { timer } from 'rxjs';

@Component({
  selector: 'app-addon',
  templateUrl: './addon.component.html',
  styleUrls: ['./addon.component.css'],
  standalone: false
})
export class AddonComponent implements OnDestroy, AfterViewInit {

  @ViewChild('objectFrame', { static: false }) objectFrame: ElementRef;

  public styleHeight: string = null;

  constructor(public service: AppService) { }

  /**
   * Perform the initial load of properties after the view has been initialized.
   */
  public ngAfterViewInit(): void {
    timer(0, 100).subscribe(t => {
      if (this.objectFrame) {
        const el = this.objectFrame.nativeElement as HTMLObjectElement;
        const height = el?.contentDocument?.getElementsByTagName('app-root')[0]?.children[0]?.scrollHeight;

        if (height && height > 0) {
          this.styleHeight = "height: " + (height + 10) + "px";
        }
      }
    });
  }

  ngOnDestroy() {
    this.service.addOnUrl = '';
  }
}
